export const WEEK_CALENDAR_DAY_INDEX_ATTR = 'data-week-calendar-day-index';
